import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { WorkshopStatus } from "../../models/workshops";

export type WorkshopListSortOrder = 0 | 1 | -1 | null | undefined;

export interface WorkshopsFiltersState {
  nameFilter: string;
  tenantId?: string;
  status?: WorkshopStatus;
  first: number;
  rows: number;
  sortField: string;
  sortOrder: WorkshopListSortOrder;
}

export const getDefaultWorkshopsFilters = (): WorkshopsFiltersState => ({
  nameFilter: "",
  tenantId: undefined,
  status: undefined,
  first: 0,
  rows: 10,
  sortField: "name",
  sortOrder: 1,
});

const initialState: WorkshopsFiltersState = getDefaultWorkshopsFilters();

const workshopsFiltersSlice = createSlice({
  name: "workshopsFilters",
  initialState,
  reducers: {
    setNameFilter: (state, action: PayloadAction<string>) => {
      state.nameFilter = action.payload;
      state.first = 0;
    },
    setTenantId: (state, action: PayloadAction<string | undefined>) => {
      state.tenantId = action.payload;
      state.first = 0;
    },
    setStatus: (state, action: PayloadAction<WorkshopStatus | undefined>) => {
      state.status = action.payload;
      state.first = 0;
    },
    setPage: (
      state,
      action: PayloadAction<{ first: number; rows: number }>
    ) => {
      state.first = action.payload.first;
      state.rows = action.payload.rows;
    },
    setSort: (
      state,
      action: PayloadAction<{
        sortField: string;
        sortOrder: WorkshopListSortOrder;
      }>
    ) => {
      state.sortField = action.payload.sortField;
      state.sortOrder = action.payload.sortOrder;
    },
    resetWorkshopsFilters: () => getDefaultWorkshopsFilters(),
  },
});

export const {
  setNameFilter,
  setTenantId,
  setStatus,
  setPage,
  setSort,
  resetWorkshopsFilters,
} = workshopsFiltersSlice.actions;

export const selectWorkshopsFilters = (state: {
  workshopsFilters: WorkshopsFiltersState;
}) => state.workshopsFilters;

export default workshopsFiltersSlice.reducer;
